export const quizNote =
  "Este test tiene fines informativos y educativos. No reemplaza diagnóstico, tratamiento ni seguimiento médico profesional. Si tenés síntomas persistentes, dolor intenso, pérdida de peso inexplicable, sangrado, vómitos frecuentes o una condición médica diagnosticada, consultá con un profesional de salud.";

export const healthDisclaimer = [
  "El contenido publicado en Mi Cocina Natural tiene fines exclusivamente educativos e informativos y no constituye asesoramiento médico, nutricional ni profesional de ningún tipo. La información aquí presentada no pretende diagnosticar, tratar, curar ni prevenir ninguna enfermedad o condición de salud, y no sustituye la consulta, el diagnóstico ni el tratamiento de un profesional de la salud calificado. Si presentas síntomas digestivos persistentes, estás embarazada, en período de lactancia, tomas medicación o tienes alguna condición médica, consulta siempre con tu médico antes de realizar cambios en tu alimentación, rutina de ejercicios o estilo de vida.",
  "Los testimonios y comentarios presentados en este sitio reflejan experiencias individuales y se muestran con fines ilustrativos. Los resultados varían de persona a persona en función de la genética, el punto de partida, la edad, los hábitos y el nivel de compromiso individual. Ninguna información en este sitio constituye una garantía o promesa de resultados específicos.",
];

export const socialDisclaimer =
  "Este sitio web no forma parte del sitio web de Facebook™ o Facebook Inc. Además, este sitio NO está respaldado, patrocinado ni administrado de ninguna manera por Facebook™, Meta Platforms, Inc., TikTok™ o ByteDance Ltd. FACEBOOK™ y TIKTOK™ son marcas comerciales registradas de sus respectivos propietarios. El acceso y uso de este sitio están sujetos a nuestras propias políticas de privacidad y términos de servicio, los cuales son independientes de las plataformas de redes sociales mencionadas.";

export interface LegalSection {
  title: string;
  body: string;
}

export const privacyPolicy: LegalSection[] = [
  {
    title: "1. Alcance",
    body: "Esta Política de Privacidad describe cómo Mi Cocina Natural trata la información de las personas que visitan este sitio y completan el test “Descubrí Qué Tipo de Cena Está Inflamando Tu Abdomen de Noche”.",
  },
  {
    title: "2. Información que recopilamos",
    body: "Las respuestas del test se procesan en tu propio navegador para generar tu perfil y no se asocian a tu nombre, correo ni datos de identificación personal. De forma automática podemos recibir datos técnicos no identificatorios, como tipo de dispositivo, navegador, ubicación aproximada, páginas visitadas y parámetros de campaña (UTM).",
  },
  {
    title: "3. Cookies y herramientas de seguimiento",
    body: "Utilizamos cookies y tecnologías similares, incluidas herramientas de atribución de campañas y píxeles de plataformas publicitarias, para medir el rendimiento del sitio y de nuestros anuncios. Podés bloquear o eliminar las cookies desde la configuración de tu navegador; algunas funciones podrían verse afectadas.",
  },
  {
    title: "4. Finalidad del uso",
    body: "Usamos la información para mostrar tu resultado personalizado, mejorar el contenido del sitio, analizar el tráfico y optimizar nuestras campañas. No vendemos ni alquilamos información personal a terceros.",
  },
  {
    title: "5. Pagos",
    body: "Las compras se realizan a través de plataformas de pago externas. Los datos de pago son tratados directamente por dichas plataformas según sus propias políticas; Mi Cocina Natural no almacena datos de tarjetas.",
  },
  {
    title: "6. Conservación y seguridad",
    body: "Conservamos los datos técnicos solo durante el tiempo necesario para las finalidades descritas y aplicamos medidas razonables para protegerlos. Ningún sistema en internet es completamente seguro.",
  },
  {
    title: "7. Tus derechos",
    body: "Según la legislación aplicable, podés solicitar acceso, rectificación o eliminación de tus datos y oponerte a su tratamiento a través de los canales disponibles en nuestros perfiles oficiales.",
  },
  {
    title: "8. Menores de edad",
    body: "Este sitio está dirigido a personas mayores de 18 años. No recopilamos intencionalmente información de menores.",
  },
  {
    title: "9. Cambios en esta política",
    body: "Podemos actualizar esta política en cualquier momento. La versión vigente será siempre la publicada en este sitio.",
  },
];

export const termsOfUse: LegalSection[] = [
  {
    title: "1. Aceptación",
    body: "Al acceder y usar este sitio aceptás estos Términos de Uso. Si no estás de acuerdo, te pedimos que no utilices el sitio.",
  },
  {
    title: "2. Naturaleza del contenido",
    body: "El test, sus resultados y todo el contenido del sitio tienen fines educativos e informativos. El “Perfil Digestivo Nocturno” no es un diagnóstico médico y no reemplaza la consulta con un profesional de la salud.",
  },
  {
    title: "3. Responsabilidad de la usuaria",
    body: "Sos responsable de las decisiones que tomes sobre tu alimentación y estilo de vida. Ante cualquier síntoma persistente o condición médica, consultá con tu médico antes de hacer cambios.",
  },
  {
    title: "4. Productos digitales",
    body: "Los productos ofrecidos son materiales digitales de uso personal. Queda prohibida su reproducción, distribución, reventa o publicación total o parcial sin autorización.",
  },
  {
    title: "5. Precios y promociones",
    body: "Los precios promocionales pueden tener una duración limitada y modificarse sin previo aviso. El precio válido es el que se muestra en la página de pago al momento de la compra.",
  },
  {
    title: "6. Garantía",
    body: "Los productos cuentan con una garantía de satisfacción de 30 días desde la compra, gestionada a través de la plataforma de pago utilizada, conforme a sus condiciones.",
  },
  {
    title: "7. Propiedad intelectual",
    body: "Textos, imágenes, logotipos y materiales de este sitio son propiedad de Mi Cocina Natural o se utilizan con autorización, y están protegidos por la legislación aplicable.",
  },
  {
    title: "8. Resultados",
    body: "Los resultados varían de persona a persona. Ninguna información del sitio constituye una garantía o promesa de resultados específicos.",
  },
  {
    title: "9. Limitación de responsabilidad",
    body: "Mi Cocina Natural no será responsable por daños derivados del uso o la imposibilidad de uso del sitio o de sus contenidos, en la máxima medida permitida por la ley.",
  },
  {
    title: "10. Modificaciones",
    body: "Podemos modificar estos términos en cualquier momento. El uso continuado del sitio implica la aceptación de la versión vigente.",
  },
];
